/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import _uniqueId from 'lodash/uniqueId';
import _map from 'lodash/map';
import iconShapes from './iconShapes';

function renderIcon(svgProps, ref) {
  const { testId, ariaHidden, ...rest } = svgProps;
  const { hidden, type, title, desc, scale } = rest;
  const iconShape = iconShapes[type];

  if (hidden || !iconShape) return null;

  const baseId = _uniqueId('mlSVG_');
  const ariaLabelledBy = `${baseId}_Aa0`;

  // Use viewBox from iconShape if available, otherwise use the passed viewBox or default
  const viewBox = iconShape.viewBox || rest.viewBox;
  const finalSvgProps = { ...rest, viewBox };

  return (
    <svg
      {...finalSvgProps}
      data-test-id={testId}
      aria-hidden={ariaHidden}
      ref={ref}
    >
      {title && <title id={ariaLabelledBy}>{title}</title>}
      {desc && <desc>{desc}</desc>}
      {iconShape && iconShape.defs && <defs>{iconShape.defs}</defs>}

      <g transform={`scale(${scale})`}>{iconShape.shape}</g>
    </svg>
  );
}

const MLIcon = React.forwardRef((props, ref) =>
  !props.hidden ? renderIcon(props, ref) : null,
);

MLIcon.listIcons = Object.keys(iconShapes);

MLIcon.defaultProps = {
  className: '',
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  scale: 1,
  color: '#000',
  role: 'img',
  tabIndex: '-1',
  title: '',
  hidden: false,
  ariaHidden: true,
};

MLIcon.propTypes = {
  type: PropTypes.string.isRequired,
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  viewBox: PropTypes.string,
  scale: PropTypes.number,
  color: PropTypes.string,
  role: PropTypes.string,
  title: PropTypes.string,
  desc: PropTypes.string,
  hidden: PropTypes.bool,
  onClick: PropTypes.func,
  testId: PropTypes.string,
};

MLIcon.__ICON_SHAPES_VIEWER = () => {
  const iconStyle = {
    fill: 'blue',
    height: 80,
    width: 80,
    fontWeight: 600,
  };

  const iconButton = {
    border: '1 px blue',
    height: 160,
    width: 160,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    margin: '10px 0 10px 0',
  };

  const container = {
    display: 'flex',
    width: 900,
    justifyContent: 'space-evenly',
    flexWrap: 'wrap',
  };
  const formatter = () =>
    _map(iconShapes, (_shape, name) => (
      <div style={iconButton}>
        <MLIcon type={name} style={iconStyle} title={name} />
        <br />
        {name}
      </div>
    ));
  return <div style={container}>{formatter()}</div>;
};

export default React.memo(MLIcon);
